export const typography = {
    family: {
        heading: '"Inter", sans-serif',
        body: '"Urbanist", sans-serif',
    },
    weight: {
        light: 300,
        regular: 400,
        medium: 500,
        semiBold: 600,
        bold: 700,
    },
    size: {
        XS: '12px',
        S: '14px',
        REG: '16px',
        M: '18px',
        L: '22px',
        XL: '26px',
        XXL: '32px',
    },
}

export const colours = {
    primary: {
        main: '#c1be7f',
        dark: '#9a976a',
        light: '#e8e7cc',
    },
    secondary: {
        main: '#dba891',
        dark: '#c4714a',
        light: '#f0d4c4',
    },
    neutral: {
        ink: '#2c2a24',
        slate: '#5c574f',
        warmStone: '#9e9589',
        parchment: '#f7f0e8',
        cream: '#f2ebe1',
        sand: '#e6ddd0',
        warmWhite: '#fdfaf6',
        sageParchment: '#e2e0c8',
    },
    contrast: {
        white: '#FFFFFF',
        offWhiteLight: '#EEEEEE',
        offWhiteDark: '#DDDDDD',
        disabled: 'rgba(0,0,0,.26)',
        grey: '#707070',
        black: '#000000',
    },
    accent: {
        honeyGold: '#d4a843',
    },
    error: {
        main: '#D74F39',
        dark: '#963727',
        light: '#DF7260',
    },
    warning: {
        main: '#FFC144',
        dark: '#976418',
        light: '#FFCD69',
    },
    info: {
        main: '#5CA1D8',
        dark: '#1E73A6',
        light: '#91D2FF',
    },
    success: {
        main: '#3B8D72',
        dark: '#29624F',
        light: '#62A38E',
    },
}
